import React from "react";
import { Award } from "lucide-react";
import MatchStatus from "./MatchStatus";

const PlayoffBracket = ({ playoffs = {} }) => {
  const allMatches = [
    { ...playoffs.semifinals?.[0], round: "Bán kết 1" },
    { ...playoffs.semifinals?.[1], round: "Bán kết 2" },
    { ...playoffs.thirdPlace, round: "Tranh hạng 3" },
    { ...playoffs.final, round: "Chung kết" },
  ];

  return (
    <div>
      <h2 className="text-xl font-bold mb-4 flex items-center">
        <Award className="mr-2 text-yellow-500" />
        Vòng chung kết
      </h2>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border shadow-sm">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                Thời gian
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Vòng
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Sân
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Đội 1
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                VĐV
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Điểm
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Đội 2
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-left">
                VĐV
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Điểm
              </th>
              <th className="px-2 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider text-center">
                Trạng thái
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {allMatches.map((match) => {
              // Tách điểm thành mảng nếu có nhiều set
              const scores = match.score
                ? match.score?.split(",")?.map((s) => s.trim())
                : [];
              const team1Score = scores.map((s) => s.split("-")[0]).join(", ");
              const team2Score = scores.map((s) => s.split("-")[1]).join(", ");

              return (
                <tr key={match.id} className="hover:bg-gray-50">
                  <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                    {match.time}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-center">
                    <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2 py-0.5 rounded">
                      {match.round}
                    </span>
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm text-center text-gray-500">
                    {match.court}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm font-medium text-center text-gray-900">
                    {match.team1?.id}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                    {match.team1?.player1 && match.team1?.player2
                      ? `${match.team1?.player1} & ${match.team1?.player2}`
                      : ""}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm font-medium text-center text-gray-900">
                    {team1Score}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm font-medium text-center text-gray-900">
                    {match.team2?.id}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm text-gray-500">
                    {match.team2?.player1 && match.team2?.player2
                      ? `${match.team2?.player1} & ${match.team2?.player2}`
                      : ""}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-sm font-medium text-center text-gray-900">
                    {team2Score}
                  </td>
                  <td className="px-2 py-3 whitespace-nowrap text-center">
                    <MatchStatus status={match.status} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlayoffBracket;
